import type { PrintJob, PrintQueue } from '../types';

const sanitizeJobForStore = (job: PrintJob): PrintJob => ({
  ...job,
  content: null,
});

export const sanitizeQueueForStore = (queue: PrintQueue): PrintQueue => ({
  ...queue,
  jobs: queue.jobs.map(sanitizeJobForStore),
});

export const sanitizeJobsForStore = (jobs: PrintJob[]): PrintJob[] => jobs.map(sanitizeJobForStore);
